module.exports = __webpack_public_path__ + "img/活用事例のご紹介.73ebc659.svg";